module.exports = __webpack_public_path__ + "img/back.07695ee6.svg";